/* Open Test: comportamiento del tema nuevo. Nada de lo visible depende de este archivo: sin JS los menús abren por CSS y los enlaces funcionan. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Menús del encabezado: clic para pantallas táctiles; Escape y clic fuera los cierran. */
  var items = $$('[data-ot-menu]');
  function closeMenus(except) {
    items.forEach(function (it) {
      if (it === except) return;
      it.classList.remove('is-open');
      var b = $('button', it);
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  items.forEach(function (it) {
    var b = $('button', it);
    if (!b) return;
    b.addEventListener('click', function () {
      var open = !it.classList.contains('is-open');
      closeMenus(it);
      it.classList.toggle('is-open', open);
      it.classList.toggle('is-closed', !open);
      b.setAttribute('aria-expanded', String(open));
    });
    it.addEventListener('mouseleave', function () { it.classList.remove('is-closed'); });
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-ot-menu]')) closeMenus(); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeMenus();
    closeDrawer();
    $$('.ot-dd[open]').forEach(function (d) { d.open = false; });
  });

  /* Menú móvil */
  var drawer = $('[data-ot-drawer]');
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var o = $('[data-ot-drawer-open]');
    if (o) { o.setAttribute('aria-expanded', 'false'); o.focus(); }
  }
  var opener = $('[data-ot-drawer-open]');
  if (opener && drawer) {
    opener.addEventListener('click', function () {
      drawer.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      opener.setAttribute('aria-expanded', 'true');
      var c = $('[data-ot-drawer-close]', drawer);
      if (c) c.focus();
    });
    $$('[data-ot-drawer-close]', drawer).forEach(function (c) { c.addEventListener('click', closeDrawer); });
  }

  /* Búsqueda */
  var sBtn = $('[data-ot-search-toggle]');
  var sBox = $('[data-ot-search]');
  if (sBtn && sBox) {
    sBtn.addEventListener('click', function () {
      var open = sBox.classList.toggle('is-open');
      sBtn.setAttribute('aria-expanded', String(open));
      if (open) { var i = $('input[type="search"]', sBox); if (i) i.focus(); }
    });
  }

  /* Idioma del examen: mueve los enlaces de empezar y de material. ?language= manda; si no hay, el idioma del navegador. */
  var root = $('[data-ot-exam]');
  if (root) {
    var data = {};
    try { JSON.parse($('[data-ot-exam-map]', root).textContent).forEach(function (x) { data[x.key] = x; }); } catch (err) {}
    var radios = $$('input[data-ot-lang]', root);
    var apply = function (key, write) {
      var d = data[key];
      if (!d) return;
      $$('[data-ot-exam-link]').forEach(function (a) { if (d.link) { a.href = d.link; a.removeAttribute('aria-disabled'); } else { a.removeAttribute('href'); a.setAttribute('aria-disabled', 'true'); } });
      $$('[data-ot-exam-pdf]').forEach(function (a) { if (d.pdf) { a.href = d.pdf; a.removeAttribute('aria-disabled'); } else { a.removeAttribute('href'); a.setAttribute('aria-disabled', 'true'); } });
      if (write) {
        try { var u = new URL(location.href); u.searchParams.set('language', key); history.replaceState({}, '', u); } catch (err) {}
      }
    };
    radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) apply(r.value, true); }); });
    var wanted = '';
    try { wanted = new URL(location.href).searchParams.get('language') || ''; } catch (err) {}
    if (!wanted) {
      var site = (document.documentElement.lang || '').slice(0, 2).toLowerCase();
      var nav = site && site !== 'en' ? site : (navigator.language || '').slice(0, 2).toLowerCase();
      wanted = { es: 'spanish', pt: 'portuguese', en: 'english' }[nav] || '';
    }
    var pick = radios.filter(function (r) { return r.value === wanted; })[0] || radios.filter(function (r) { return r.checked; })[0];
    if (pick) { pick.checked = true; apply(pick.value, false); }
  }

  /* Rieles con flechas (testimonios). El temporizador cubre las vistas donde el scroll suave no avanza. */
  $$('[data-ot-rail]').forEach(function (rail) {
    var scope = rail.closest('[data-ot-rail-scope]') || rail.parentNode;
    var prev = $('[data-ot-prev]', scope), next = $('[data-ot-next]', scope);
    var sync = function () {
      var max = rail.scrollWidth - rail.clientWidth - 1;
      if (prev) prev.disabled = rail.scrollLeft <= 1;
      if (next) next.disabled = rail.scrollLeft >= max;
    };
    var go = function (dir) {
      var card = rail.firstElementChild;
      var step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0) : rail.clientWidth;
      var from = rail.scrollLeft, to = from + dir * step;
      rail.scrollBy({ left: dir * step, behavior: 'smooth' });
      setTimeout(function () { if (rail.scrollLeft === from) rail.scrollLeft = to; sync(); }, 450);
    };
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* Orden de la colección: sin JS el formulario sigue enviando con el botón oculto */
  $$('[data-ot-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      location.href = u.toString();
    });
  });

  /* Solo un desplegable abierto y se cierra al hacer clic fuera */
  document.addEventListener('click', function (e) {
    $$('.ot-dd[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
  });
})();
